import {OidcService} from '~/openapi';
import {UserState} from '~/stores/crmStateStore';
import {useShoppingListsStore} from '~/stores/shoppingLists';

export default function useSessionActions() {
	const {runWithContext} = useNuxtApp();
	const {clearLocalState} = useAuth();
	const {redirectToCrm} = useCrmRedirect();
	const shoppingListsStore = useShoppingListsStore();

	function clearLocalSession(): void {
		clearLocalState();
		shoppingListsStore.clearCachedShoppingLists();
	}

	async function signOut({disabledCrmRedirect}: {disabledCrmRedirect?: boolean}): Promise<void> {
		try {
			await cancelTimeout(() => (OidcService.logoutSession({})));
		} catch (e: any) {
			throw createError({
				message: 'Failed to logout session',
				cause: e,
			});
		}

		clearLocalSession();

		if (!disabledCrmRedirect) {
			await runWithContext(() => redirectToCrm(UserState.LOGOUT));
		} else {
			await runWithContext(() => navigateTo('/'));
		}
	}

	return {signOut, clearLocalSession};
}
